// extracted by mini-css-extract-plugin
module.exports = {"container":"backLink__container___2J6SF","back":"backLink__back___3sMf_"};